import React from "react";

// Cartes de rôle d'un compte d'opérateur (radios habillés, maquette 10),
// partagées par la modale de création et la fiche d'un compte. `roles` vient
// de rolesProposes : un rôle `disabled` porte son `aide` (« Attribué par la
// Caf. ») ; `verrouille` fige tous les rôles (rôle d'un administrateur vu par
// un administrateur d'opérateur).
const CartesRolesCompte = ({ roles = [], valeur, onChange, verrouille = false, erreur = null, name = "role" }) => (
  <fieldset className="modale-operateur__section">
    <legend className="modale-operateur__legende">
      Rôle
      <span className="text-danger ml-1" aria-hidden="true">
        *
      </span>
    </legend>
    <div className="choix-roles">
      {roles.map((role) => {
        const inactif = Boolean(role.disabled) || verrouille;
        return (
          <label
            key={role.id}
            className={`choix-role${valeur === role.id ? " is-checked" : ""}${inactif ? " is-disabled" : ""}`}
          >
            <input
              type="radio"
              name={name}
              value={role.id}
              checked={valeur === role.id}
              disabled={inactif}
              onChange={() => onChange(role.id)}
            />
            <span>
              <span className="choix-role__titre">{role.name}</span>
              <span className="choix-role__description">
                {role.description}
                {role.aide ? ` ${role.aide}` : ""}
              </span>
            </span>
          </label>
        );
      })}
    </div>
    {erreur && (
      <small role="alert" className="form-text text-danger">
        {erreur}
      </small>
    )}
    {verrouille && <p className="modale-operateur__aide">Le rôle d'un administrateur est fixé par la Caf.</p>}
  </fieldset>
);

export default CartesRolesCompte;
